"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mergeCallbacks = void 0;
const mergeCallbacks = (...callbacks) => {
    return (...args) => {
        callbacks.forEach((func) => func === null || func === void 0 ? void 0 : func(...args));
    };
};
exports.mergeCallbacks = mergeCallbacks;
//# sourceMappingURL=mergeCallbacks.js.map